import { loading as catalogueLoading } from 'mailhosting/catalogue/subs'
import { createSelector } from '@reduxjs/toolkit'
import { loading as domainsLoading } from 'mailhosting/domain/subs'

export const loading = createSelector(
  domainsLoading,
  catalogueLoading,
  (domainsLoading, catalogueLoading) => Boolean(domainsLoading || catalogueLoading)
)
